import React from 'react'
import Layout from '../Components/Layouts/Layout'

const Error = () => {
  return (
    <Layout>  <h1>Page Not Found!</h1></Layout>
    
   
  )
}

export default Error
